export default __webpack_public_path__ + "static/media/revlogo.25a50a83.png";